import colors from "vuetify/lib/util/colors"

export default {
  methods: {
    $dd_register_type: function(key) {
      let data = [
        { key: "user", text: this.$t("global.dd_register_type_user") },
        { key: "company", text: this.$t("global.dd_register_type_company") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },
    $dd_modules: function(key) {
      let data = [
        { key: "users", text: this.$t("global.dd_modules_users") },
        { key: "roles", text: this.$t("global.dd_modules_roles") },
        { key: "permissions", text: this.$t("global.dd_modules_permissions") },
        { key: "settings", text: this.$t("global.dd_modules_settings") },
        { key: "logs", text: this.$t("global.dd_modules_logs") },
        { key: "queues", text: this.$t("global.dd_modules_queues") },
        { key: "persons", text: this.$t("global.dd_modules_persons") },
        { key: "companies", text: this.$t("global.dd_modules_companies") },
        { key: "certificates", text: this.$t("global.dd_modules_certificates") }
      ]

      if (!this.$hasRole("system-developer")) {
        _.remove(data, (item) => item.key === "permissions")
        _.remove(data, (item) => item.key === "queues")
      }

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_action_models: function(key) {
      let data = [
        { key: "certificate", text: this.$t("certificates.title") },
        { key: "company", text: this.$t("companies.title") },
        { key: "permission", text: this.$t("global.dd_modules_permissions") },
        { key: "role", text: this.$t("global.dd_modules_roles") },
        { key: "setting", text: this.$t("global.dd_modules_settings") },
        { key: "user", text: this.$t("global.dd_modules_users") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_locales: function(key) {
      let data = [
        { key: "en", text: this.$t("global.dd_locales_en") },
        { key: "no", text: this.$t("global.dd_locales_no") }
        //{ key: 'nn', text: this.$t("global.dd_locales_nn") },
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_user_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_user_status_inactive") },
        { key: 1, text: this.$t("global.dd_user_status_active") }
        //{ key: 3, text: this.$t("global.dd_user_status_force_change") },
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_tennant_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_tennant_status_inactive") },
        { key: 1, text: this.$t("global.dd_tennant_status_active"), default: true },
        { key: 2, text: this.$t("global.dd_tennant_status_not_created"), default: true },
        { key: 3, text: this.$t("global.dd_tennant_status_in_progress"), default: true },
        { key: 4, text: this.$t("global.dd_tennant_status_failed"), default: true }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_titles: function(key) {
      let data = [
        { key: "Mr", text: this.$t("global.dd_titles_mr") },
        { key: "Mrs", text: this.$t("global.dd_titles_mrs") },
        { key: "Ms", text: this.$t("global.dd_titles_ms") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_templates_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_course_templates_status_inactive") },
        { key: 1, text: this.$t("global.dd_course_templates_status_active") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_template_types: function(key) {
      let data = [
        { key: "documented", text: this.$t("global.dd_course_template_types_documented") },
        { key: "certified", text: this.$t("global.dd_course_template_types_certified") },
        { key: "hotwork", text: this.$t("global.dd_course_template_types_hotwork") },
        { key: "instructor_documented", text: this.$t("global.dd_course_template_types_instructor_documented") },
        { key: "controller", text: this.$t("global.dd_course_template_types_controller") },
        { key: "other", text: this.$t("global.dd_course_template_types_other") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_type_groups_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_course_type_groups_status_inactive") },
        { key: 1, text: this.$t("global.dd_course_type_groups_status_active"), default: true }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_types_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_course_types_status_inactive") },
        { key: 1, text: this.$t("global.dd_course_types_status_active"), default: true }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_attendees_theory_test: function(key) {
      let data = [
        { key: 1, text: this.$t("global.dd_attendees_theory_test_na") },
        { key: 2, text: this.$t("global.dd_attendees_theory_test_passed") },
        { key: 3, text: this.$t("global.dd_attendees_theory_test_failed") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_enrolment_status: function(key) {
      let data = [
        { key: 1, text: this.$t("global.dd_course_enrolment_status_enrolled") },
        { key: 2, text: this.$t("global.dd_course_enrolment_status_attending") },
        { key: 3, text: this.$t("global.dd_course_enrolment_status_completed") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_classes_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_classes_status_inactive") },
        { key: 1, text: this.$t("global.dd_classes_status_active"), default: true }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_classes_duration_type: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_classes_duration_type_min"), default: true },
        { key: 1, text: this.$t("global.dd_classes_duration_type_hours") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_certificate_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_certificate_status_not_confirmed") },
        { key: 1, text: this.$t("global.dd_certificate_status_confirmed"), default: true }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_type_groups_type: function(key) {
      let data = [
        {
          key: 0,
          text: this.$t("global.dd_course_type_groups_type_certified")
        },
        {
          key: 1,
          text: this.$t("global.dd_course_type_groups_type_documented")
        },
        {
          key: 2,
          text: this.$t("global.dd_course_type_groups_type_undocumented")
        }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_countries: function(key) {
      let data = [
        { key: "AFG", text: this.$t("global.dd_countries_AFG") },
        { key: "ALA", text: this.$t("global.dd_countries_ALA") },
        { key: "ALB", text: this.$t("global.dd_countries_ALB") },
        { key: "DZA", text: this.$t("global.dd_countries_DZA") },
        { key: "ASM", text: this.$t("global.dd_countries_ASM") },
        { key: "AND", text: this.$t("global.dd_countries_AND") },
        { key: "AGO", text: this.$t("global.dd_countries_AGO") },
        { key: "AIA", text: this.$t("global.dd_countries_AIA") },
        { key: "ATA", text: this.$t("global.dd_countries_ATA") },
        { key: "ATG", text: this.$t("global.dd_countries_ATG") },
        { key: "ARG", text: this.$t("global.dd_countries_ARG") },
        { key: "ARM", text: this.$t("global.dd_countries_ARM") },
        { key: "ABW", text: this.$t("global.dd_countries_ABW") },
        { key: "AUS", text: this.$t("global.dd_countries_AUS") },
        { key: "AUT", text: this.$t("global.dd_countries_AUT") },
        { key: "AZE", text: this.$t("global.dd_countries_AZE") },
        { key: "BHS", text: this.$t("global.dd_countries_BHS") },
        { key: "BHR", text: this.$t("global.dd_countries_BHR") },
        { key: "BGD", text: this.$t("global.dd_countries_BGD") },
        { key: "BRB", text: this.$t("global.dd_countries_BRB") },
        { key: "BLR", text: this.$t("global.dd_countries_BLR") },
        { key: "BEL", text: this.$t("global.dd_countries_BEL") },
        { key: "BLZ", text: this.$t("global.dd_countries_BLZ") },
        { key: "BEN", text: this.$t("global.dd_countries_BEN") },
        { key: "BMU", text: this.$t("global.dd_countries_BMU") },
        { key: "BTN", text: this.$t("global.dd_countries_BTN") },
        { key: "BOL", text: this.$t("global.dd_countries_BOL") },
        { key: "BES", text: this.$t("global.dd_countries_BES") },
        { key: "BIH", text: this.$t("global.dd_countries_BIH") },
        { key: "BWA", text: this.$t("global.dd_countries_BWA") },
        { key: "BVT", text: this.$t("global.dd_countries_BVT") },
        { key: "BRA", text: this.$t("global.dd_countries_BRA") },
        { key: "IOT", text: this.$t("global.dd_countries_IOT") },
        { key: "BRN", text: this.$t("global.dd_countries_BRN") },
        { key: "BGR", text: this.$t("global.dd_countries_BGR") },
        { key: "BFA", text: this.$t("global.dd_countries_BFA") },
        { key: "BDI", text: this.$t("global.dd_countries_BDI") },
        { key: "KHM", text: this.$t("global.dd_countries_KHM") },
        { key: "CMR", text: this.$t("global.dd_countries_CMR") },
        { key: "CAN", text: this.$t("global.dd_countries_CAN") },
        { key: "CPV", text: this.$t("global.dd_countries_CPV") },
        { key: "CYM", text: this.$t("global.dd_countries_CYM") },
        { key: "CAF", text: this.$t("global.dd_countries_CAF") },
        { key: "TCD", text: this.$t("global.dd_countries_TCD") },
        { key: "CHL", text: this.$t("global.dd_countries_CHL") },
        { key: "CHN", text: this.$t("global.dd_countries_CHN") },
        { key: "CXR", text: this.$t("global.dd_countries_CXR") },
        { key: "CCK", text: this.$t("global.dd_countries_CCK") },
        { key: "COL", text: this.$t("global.dd_countries_COL") },
        { key: "COM", text: this.$t("global.dd_countries_COM") },
        { key: "COG", text: this.$t("global.dd_countries_COG") },
        { key: "COD", text: this.$t("global.dd_countries_COD") },
        { key: "COK", text: this.$t("global.dd_countries_COK") },
        { key: "CRI", text: this.$t("global.dd_countries_CRI") },
        { key: "CIV", text: this.$t("global.dd_countries_CIV") },
        { key: "HRV", text: this.$t("global.dd_countries_HRV") },
        { key: "CUB", text: this.$t("global.dd_countries_CUB") },
        { key: "CUW", text: this.$t("global.dd_countries_CUW") },
        { key: "CYP", text: this.$t("global.dd_countries_CYP") },
        { key: "CZE", text: this.$t("global.dd_countries_CZE") },
        { key: "DNK", text: this.$t("global.dd_countries_DNK") },
        { key: "DJI", text: this.$t("global.dd_countries_DJI") },
        { key: "DMA", text: this.$t("global.dd_countries_DMA") },
        { key: "DOM", text: this.$t("global.dd_countries_DOM") },
        { key: "ECU", text: this.$t("global.dd_countries_ECU") },
        { key: "EGY", text: this.$t("global.dd_countries_EGY") },
        { key: "SLV", text: this.$t("global.dd_countries_SLV") },
        { key: "GNQ", text: this.$t("global.dd_countries_GNQ") },
        { key: "ERI", text: this.$t("global.dd_countries_ERI") },
        { key: "EST", text: this.$t("global.dd_countries_EST") },
        { key: "ETH", text: this.$t("global.dd_countries_ETH") },
        { key: "FLK", text: this.$t("global.dd_countries_FLK") },
        { key: "FRO", text: this.$t("global.dd_countries_FRO") },
        { key: "FJI", text: this.$t("global.dd_countries_FJI") },
        { key: "FIN", text: this.$t("global.dd_countries_FIN") },
        { key: "FRA", text: this.$t("global.dd_countries_FRA") },
        { key: "GUF", text: this.$t("global.dd_countries_GUF") },
        { key: "PYF", text: this.$t("global.dd_countries_PYF") },
        { key: "ATF", text: this.$t("global.dd_countries_ATF") },
        { key: "GAB", text: this.$t("global.dd_countries_GAB") },
        { key: "GMB", text: this.$t("global.dd_countries_GMB") },
        { key: "GEO", text: this.$t("global.dd_countries_GEO") },
        { key: "DEU", text: this.$t("global.dd_countries_DEU") },
        { key: "GHA", text: this.$t("global.dd_countries_GHA") },
        { key: "GIB", text: this.$t("global.dd_countries_GIB") },
        { key: "GRC", text: this.$t("global.dd_countries_GRC") },
        { key: "GRL", text: this.$t("global.dd_countries_GRL") },
        { key: "GRD", text: this.$t("global.dd_countries_GRD") },
        { key: "GLP", text: this.$t("global.dd_countries_GLP") },
        { key: "GUM", text: this.$t("global.dd_countries_GUM") },
        { key: "GTM", text: this.$t("global.dd_countries_GTM") },
        { key: "GGY", text: this.$t("global.dd_countries_GGY") },
        { key: "GIN", text: this.$t("global.dd_countries_GIN") },
        { key: "GNB", text: this.$t("global.dd_countries_GNB") },
        { key: "GUY", text: this.$t("global.dd_countries_GUY") },
        { key: "HTI", text: this.$t("global.dd_countries_HTI") },
        { key: "HMD", text: this.$t("global.dd_countries_HMD") },
        { key: "VAT", text: this.$t("global.dd_countries_VAT") },
        { key: "HND", text: this.$t("global.dd_countries_HND") },
        { key: "HKG", text: this.$t("global.dd_countries_HKG") },
        { key: "HUN", text: this.$t("global.dd_countries_HUN") },
        { key: "ISL", text: this.$t("global.dd_countries_ISL") },
        { key: "IND", text: this.$t("global.dd_countries_IND") },
        { key: "IDN", text: this.$t("global.dd_countries_IDN") },
        { key: "IRN", text: this.$t("global.dd_countries_IRN") },
        { key: "IRQ", text: this.$t("global.dd_countries_IRQ") },
        { key: "IRL", text: this.$t("global.dd_countries_IRL") },
        { key: "IMN", text: this.$t("global.dd_countries_IMN") },
        { key: "ISR", text: this.$t("global.dd_countries_ISR") },
        { key: "ITA", text: this.$t("global.dd_countries_ITA") },
        { key: "JAM", text: this.$t("global.dd_countries_JAM") },
        { key: "JPN", text: this.$t("global.dd_countries_JPN") },
        { key: "JEY", text: this.$t("global.dd_countries_JEY") },
        { key: "JOR", text: this.$t("global.dd_countries_JOR") },
        { key: "KAZ", text: this.$t("global.dd_countries_KAZ") },
        { key: "KEN", text: this.$t("global.dd_countries_KEN") },
        { key: "KIR", text: this.$t("global.dd_countries_KIR") },
        { key: "PRK", text: this.$t("global.dd_countries_PRK") },
        { key: "KOR", text: this.$t("global.dd_countries_KOR") },
        { key: "KWT", text: this.$t("global.dd_countries_KWT") },
        { key: "KGZ", text: this.$t("global.dd_countries_KGZ") },
        { key: "LAO", text: this.$t("global.dd_countries_LAO") },
        { key: "LVA", text: this.$t("global.dd_countries_LVA") },
        { key: "LBN", text: this.$t("global.dd_countries_LBN") },
        { key: "LSO", text: this.$t("global.dd_countries_LSO") },
        { key: "LBR", text: this.$t("global.dd_countries_LBR") },
        { key: "LBY", text: this.$t("global.dd_countries_LBY") },
        { key: "LIE", text: this.$t("global.dd_countries_LIE") },
        { key: "LTU", text: this.$t("global.dd_countries_LTU") },
        { key: "LUX", text: this.$t("global.dd_countries_LUX") },
        { key: "MAC", text: this.$t("global.dd_countries_MAC") },
        { key: "MKD", text: this.$t("global.dd_countries_MKD") },
        { key: "MDG", text: this.$t("global.dd_countries_MDG") },
        { key: "MWI", text: this.$t("global.dd_countries_MWI") },
        { key: "MYS", text: this.$t("global.dd_countries_MYS") },
        { key: "MDV", text: this.$t("global.dd_countries_MDV") },
        { key: "MLI", text: this.$t("global.dd_countries_MLI") },
        { key: "MLT", text: this.$t("global.dd_countries_MLT") },
        { key: "MHL", text: this.$t("global.dd_countries_MHL") },
        { key: "MTQ", text: this.$t("global.dd_countries_MTQ") },
        { key: "MRT", text: this.$t("global.dd_countries_MRT") },
        { key: "MUS", text: this.$t("global.dd_countries_MUS") },
        { key: "MYT", text: this.$t("global.dd_countries_MYT") },
        { key: "MEX", text: this.$t("global.dd_countries_MEX") },
        { key: "FSM", text: this.$t("global.dd_countries_FSM") },
        { key: "MDA", text: this.$t("global.dd_countries_MDA") },
        { key: "MCO", text: this.$t("global.dd_countries_MCO") },
        { key: "MNG", text: this.$t("global.dd_countries_MNG") },
        { key: "MNE", text: this.$t("global.dd_countries_MNE") },
        { key: "MSR", text: this.$t("global.dd_countries_MSR") },
        { key: "MAR", text: this.$t("global.dd_countries_MAR") },
        { key: "MOZ", text: this.$t("global.dd_countries_MOZ") },
        { key: "MMR", text: this.$t("global.dd_countries_MMR") },
        { key: "NAM", text: this.$t("global.dd_countries_NAM") },
        { key: "NRU", text: this.$t("global.dd_countries_NRU") },
        { key: "NPL", text: this.$t("global.dd_countries_NPL") },
        { key: "NLD", text: this.$t("global.dd_countries_NLD") },
        { key: "NCL", text: this.$t("global.dd_countries_NCL") },
        { key: "NZL", text: this.$t("global.dd_countries_NZL") },
        { key: "NIC", text: this.$t("global.dd_countries_NIC") },
        { key: "NER", text: this.$t("global.dd_countries_NER") },
        { key: "NGA", text: this.$t("global.dd_countries_NGA") },
        { key: "NIU", text: this.$t("global.dd_countries_NIU") },
        { key: "NFK", text: this.$t("global.dd_countries_NFK") },
        { key: "MNP", text: this.$t("global.dd_countries_MNP") },
        { key: "NOR", text: this.$t("global.dd_countries_NOR"), default: true },
        { key: "OMN", text: this.$t("global.dd_countries_OMN") },
        { key: "PAK", text: this.$t("global.dd_countries_PAK") },
        { key: "PLW", text: this.$t("global.dd_countries_PLW") },
        { key: "PSE", text: this.$t("global.dd_countries_PSE") },
        { key: "PAN", text: this.$t("global.dd_countries_PAN") },
        { key: "PNG", text: this.$t("global.dd_countries_PNG") },
        { key: "PRY", text: this.$t("global.dd_countries_PRY") },
        { key: "PER", text: this.$t("global.dd_countries_PER") },
        { key: "PHL", text: this.$t("global.dd_countries_PHL") },
        { key: "PCN", text: this.$t("global.dd_countries_PCN") },
        { key: "POL", text: this.$t("global.dd_countries_POL") },
        { key: "PRT", text: this.$t("global.dd_countries_PRT") },
        { key: "PRI", text: this.$t("global.dd_countries_PRI") },
        { key: "QAT", text: this.$t("global.dd_countries_QAT") },
        { key: "REU", text: this.$t("global.dd_countries_REU") },
        { key: "ROU", text: this.$t("global.dd_countries_ROU") },
        { key: "RUS", text: this.$t("global.dd_countries_RUS") },
        { key: "RWA", text: this.$t("global.dd_countries_RWA") },
        { key: "BLM", text: this.$t("global.dd_countries_BLM") },
        { key: "SHN", text: this.$t("global.dd_countries_SHN") },
        { key: "KNA", text: this.$t("global.dd_countries_KNA") },
        { key: "LCA", text: this.$t("global.dd_countries_LCA") },
        { key: "MAF", text: this.$t("global.dd_countries_MAF") },
        { key: "SPM", text: this.$t("global.dd_countries_SPM") },
        { key: "VCT", text: this.$t("global.dd_countries_VCT") },
        { key: "WSM", text: this.$t("global.dd_countries_WSM") },
        { key: "SMR", text: this.$t("global.dd_countries_SMR") },
        { key: "STP", text: this.$t("global.dd_countries_STP") },
        { key: "SAU", text: this.$t("global.dd_countries_SAU") },
        { key: "SEN", text: this.$t("global.dd_countries_SEN") },
        { key: "SRB", text: this.$t("global.dd_countries_SRB") },
        { key: "SYC", text: this.$t("global.dd_countries_SYC") },
        { key: "SLE", text: this.$t("global.dd_countries_SLE") },
        { key: "SGP", text: this.$t("global.dd_countries_SGP") },
        { key: "SXM", text: this.$t("global.dd_countries_SXM") },
        { key: "SVK", text: this.$t("global.dd_countries_SVK") },
        { key: "SVN", text: this.$t("global.dd_countries_SVN") },
        { key: "SLB", text: this.$t("global.dd_countries_SLB") },
        { key: "SOM", text: this.$t("global.dd_countries_SOM") },
        { key: "ZAF", text: this.$t("global.dd_countries_ZAF") },
        { key: "SGS", text: this.$t("global.dd_countries_SGS") },
        { key: "SSD", text: this.$t("global.dd_countries_SSD") },
        { key: "ESP", text: this.$t("global.dd_countries_ESP") },
        { key: "LKA", text: this.$t("global.dd_countries_LKA") },
        { key: "SDN", text: this.$t("global.dd_countries_SDN") },
        { key: "SUR", text: this.$t("global.dd_countries_SUR") },
        { key: "SJM", text: this.$t("global.dd_countries_SJM") },
        { key: "SWZ", text: this.$t("global.dd_countries_SWZ") },
        { key: "SWE", text: this.$t("global.dd_countries_SWE") },
        { key: "CHE", text: this.$t("global.dd_countries_CHE") },
        { key: "SYR", text: this.$t("global.dd_countries_SYR") },
        { key: "TWN", text: this.$t("global.dd_countries_TWN") },
        { key: "TJK", text: this.$t("global.dd_countries_TJK") },
        { key: "TZA", text: this.$t("global.dd_countries_TZA") },
        { key: "THA", text: this.$t("global.dd_countries_THA") },
        { key: "TLS", text: this.$t("global.dd_countries_TLS") },
        { key: "TGO", text: this.$t("global.dd_countries_TGO") },
        { key: "TKL", text: this.$t("global.dd_countries_TKL") },
        { key: "TON", text: this.$t("global.dd_countries_TON") },
        { key: "TTO", text: this.$t("global.dd_countries_TTO") },
        { key: "TUN", text: this.$t("global.dd_countries_TUN") },
        { key: "TUR", text: this.$t("global.dd_countries_TUR") },
        { key: "TKM", text: this.$t("global.dd_countries_TKM") },
        { key: "TCA", text: this.$t("global.dd_countries_TCA") },
        { key: "TUV", text: this.$t("global.dd_countries_TUV") },
        { key: "UGA", text: this.$t("global.dd_countries_UGA") },
        { key: "UKR", text: this.$t("global.dd_countries_UKR") },
        { key: "ARE", text: this.$t("global.dd_countries_ARE") },
        { key: "GBR", text: this.$t("global.dd_countries_GBR") },
        { key: "USA", text: this.$t("global.dd_countries_USA") },
        { key: "UMI", text: this.$t("global.dd_countries_UMI") },
        { key: "URY", text: this.$t("global.dd_countries_URY") },
        { key: "UZB", text: this.$t("global.dd_countries_UZB") },
        { key: "VUT", text: this.$t("global.dd_countries_VUT") },
        { key: "VEN", text: this.$t("global.dd_countries_VEN") },
        { key: "VNM", text: this.$t("global.dd_countries_VNM") },
        { key: "VGB", text: this.$t("global.dd_countries_VGB") },
        { key: "VIR", text: this.$t("global.dd_countries_VIR") },
        { key: "WLF", text: this.$t("global.dd_countries_WLF") },
        { key: "ESH", text: this.$t("global.dd_countries_ESH") },
        { key: "YEM", text: this.$t("global.dd_countries_YEM") },
        { key: "ZMB", text: this.$t("global.dd_countries_ZMB") },
        { key: "ZWE", text: this.$t("global.dd_countries_ZWE") }
      ]

      if (key !== undefined) {
        let item = data.find((i) => i.key === key)
        return item ? item.text : ""
      }

      return data
    }
  }
}
